import React from "react";
import { Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom'
import styled from "styled-components";
import { useSelector } from "react-redux";
import AuthenticatedHome from "./AuthenticatedHome";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const Div = styled.div`
    max-width: 100%;
    opacity: 0.9;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 20% 0;
    margin-top: 7rem;
    margin-bottom: 0rem;
    /* margin-top: 25%; */


    /* margin-top: auto;
    margin-bottom: auto; */
    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        max-width: 80%;
        margin-top: 14rem;
        margin-bottom: 13rem;
        border: 1px grey solid;
        border-radius: 1.4%;
        padding: 2% 0;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        /* margin-bottom: 7rem; */
        margin-top: 11rem;
        border-radius: 1.4%;
        max-width: 45%;
    }
`

const StyledButton = styled(Button)`
    width: 150px;
`

const Home = () => {
    const userInfo = useSelector(state => state.userInfo)

    let history = useHistory()
    const toAbout = () => {
        history.push('/about')
    }

    const toLogin = () => {
        history.push('/login')
    }

    return (
        <>
            {userInfo ? <AuthenticatedHome userInfo={userInfo} />:
                <Div>
                    <Grid container direction={"column"} spacing={2}>
                        <Grid item>
                            <h4 style={{color: 'green'}}>NGHS ENVIRONMENTAL CLUB</h4>
                        </Grid>
                        <Grid item>
                        <MuiThemeProvider theme={greenTheme}>
                            <StyledButton type='submit' variant='contained' color='primary' onClick={toAbout} style={{fontWeight: 'bold'}}>
                                LEARN MORE
                            </StyledButton>
                        </MuiThemeProvider>
                        </Grid>
                        <Grid item>
                            <MuiThemeProvider theme={greenTheme}>
                            <StyledButton type='submit' variant='contained' color='primary' onClick={toLogin} style={{fontWeight: 'bold'}}>
                                LOG IN
                            </StyledButton>
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                </Div>
            }
        </>
    );
};

export default Home;